module.exports = __webpack_public_path__ + "img/img-bottom1.278aaf05.png";